var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { TransitionGroup } from "react-transition-group";
import { RippleColorNames } from "../../../theme";
import Ripple from "./Ripple";
import clsx from "clsx";
import styles from "./TouchRipple.module.scss";
const TouchRipple = React.forwardRef(function TouchRipple(props, ref) {
    const { center: centerProp = false, classes = {
        root: "",
        ripple: "",
        rippleVisible: "",
        ripplePulsate: "",
        child: "",
        childLeaving: "",
        childPulsate: "",
    }, className, rippleColor, duration: durationProp } = props, other = __rest(props, ["center", "classes", "className", "rippleColor", "duration"]);
    // TODO: remove any
    const [ripples, setRipples] = React.useState([]);
    const nextKey = React.useRef(0);
    const rippleCallback = React.useRef(null);
    const duration = durationProp !== null && durationProp !== void 0 ? durationProp : 450;
    React.useEffect(() => {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [ripples]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = React.useRef(false);
    const container = React.useRef(null);
    const startCommit = React.useCallback((params) => {
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples) => [
            React.createElement(Ripple, { className: styles.TouchRippleRipple, key: nextKey.current, classes: {
                    root: "",
                    ripple: clsx(classes.ripple, styles.Ripple),
                    rippleVisible: clsx(classes.rippleVisible, styles.RippleVisible),
                    ripplePulsate: clsx(classes.ripplePulsate, styles.RipplePulsate),
                    child: clsx(classes.child, styles.Child, {
                        [styles.RippleColor]: rippleColor == RippleColorNames.color_ripple,
                        [styles.PrimaryRippleColor]: rippleColor == RippleColorNames.color_primary_ripple,
                        [styles.ErrorRippleColor]: rippleColor == RippleColorNames.color_error_ripple,
                    }),
                    childLeaving: clsx(classes.childLeaving, styles.ChildLeaving),
                    childPulsate: clsx(classes.childPulsate, styles.ChildPulsate),
                }, timeout: duration, pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize }),
        ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [classes, props.rippleColor]);
    const start = React.useCallback(
    //todo: fix any !!!!!
    (event, options = {}, cb = () => { }) => {
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false, // For test purposes
         } = options;
        if ((event === null || event === void 0 ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event === null || event === void 0 ? void 0 : event.type) === "touchstart") {
            ignoringMouseDown.current = true;
        }
        const element = fakeElement ? null : container.current;
        const rect = element
            ? element.getBoundingClientRect()
            : {
                width: 0,
                height: 0,
                left: 0,
                top: 0,
            };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center ||
            event === undefined ||
            (event.clientX === 0 && event.clientY === 0) ||
            (!event.clientX && !event.touches)) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        }
        else {
            const { clientX, clientY } = event.touches && event.touches.length > 0
                ? event.touches[0]
                : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) {
                rippleSize += 1;
            }
        }
        else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) *
                2 +
                2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) *
                2 +
                2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        }
        startCommit({ pulsate, rippleX, rippleY, rippleSize, cb });
    }, [centerProp, startCommit]);
    const pulsate = React.useCallback(() => {
        start({}, { pulsate: true });
    }, [start]);
    const stop = React.useCallback((event, cb) => {
        setRipples((oldRipples) => {
            if (oldRipples.length > 0) {
                return [oldRipples[oldRipples.length - 1]];
            }
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    const forceClear = React.useCallback(() => {
        setRipples([]);
    }, []);
    React.useImperativeHandle(ref, () => ({
        pulsate,
        start,
        stop,
        forceClear,
    }), [pulsate, start, stop, forceClear]);
    return (React.createElement("span", Object.assign({ className: clsx(styles.TouchRippleRoot, classes.root, className), ref: container }, other),
        React.createElement(TransitionGroup, { component: null, exit: true }, ripples)));
});
TouchRipple.defaultProps = {
    rippleColor: RippleColorNames.color_primary_ripple,
};
export default TouchRipple;
//# sourceMappingURL=TouchRipple.js.map